import React, { useState } from 'react';
import { Button, Label, TextInput, Card, Alert, Spinner } from 'flowbite-react';

const API_URL = process.env.REACT_APP_DASHBOARD_API || 'http://localhost:8000/dashboard-api';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [organization, setOrganization] = useState('');
  const [phone, setPhone] = useState('');
  const [agree, setAgree] = useState(false);
  const [errors, setErrors] = useState({});
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');
  const [loading, setLoading] = useState(false);

  const formatPhone = (value) => {
    const digits = (value || '').replace(/\D/g, '');
    let d = digits;
    if (d.startsWith('8')) d = '7' + d.slice(1);
    if (!d.startsWith('7')) d = '7' + d;
    d = d.slice(0, 11);
    const rest = d.slice(1);
    let out = '+7';
    if (rest.length > 0) out += ' ' + rest.slice(0, 3);
    if (rest.length > 3) out += ' ' + rest.slice(3, 6);
    if (rest.length > 6) out += '-' + rest.slice(6, 8);
    if (rest.length > 8) out += '-' + rest.slice(8, 10);
    return out;
  };

  const normalizePhone = (value) => {
    const digits = (value || '').replace(/\D/g, '');
    let d = digits;
    if (d.startsWith('8')) d = '7' + d.slice(1);
    if (!d.startsWith('7')) d = '7' + d;
    d = d.slice(0, 11);
    return '+' + d;
  };

  const validate = () => {
    const next = {};
    if (!firstName.trim()) next.first_name = 'Укажите имя';
    if (!lastName.trim()) next.last_name = 'Укажите фамилию';

    const phoneNorm = normalizePhone(phone);
    if (!/^\+7\d{10}$/.test(phoneNorm)) next.phone = 'Телефон должен быть в формате +7XXXXXXXXXX';

    if (!email.trim()) next.email = 'Укажите email';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) next.email = 'Некорректный email';

    if (!password) next.password = 'Укажите пароль';
    else if (password.length < 8) next.password = 'Минимальная длина пароля — 8 символов';

    if (!agree) next.agree = 'Нужно согласиться с условиями';

    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setOk('');
    try {
      if (!validate()) return;
      const res = await fetch(`${API_URL}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim(),
          password,
          first_name: firstName.trim(),
          last_name: lastName.trim(),
          organization: organization.trim() || null,
          phone: normalizePhone(phone),
        })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Ошибка регистрации');
      setOk('Регистрация успешна. Теперь войдите.');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const canSubmit = !loading && agree;

  return (
    <div className="flex justify-center items-center min-h-[80vh]">
      <Card className="w-full max-w-md text-gray-900">
        <div className="text-center mb-6">
          <div className="flex items-center justify-center mb-4">
            <span className="text-4xl mr-3">🏠</span>
            <div>
              <h1 className="text-3xl font-bold">
                <span className="text-blue-600">Real</span>
                <span className="text-gray-800">gram</span>
              </h1>
              <p className="text-sm text-gray-500">Панель управления</p>
            </div>
          </div>
          <h2 className="text-xl font-semibold">Регистрация</h2>
          <p className="mt-2 text-sm text-gray-600">Платформа для управления недвижимостью в телеграм</p>
          <p className="text-sm text-gray-600">Сделано с ❤️ для агентов недвижимости</p>
        </div>
        {error && (
          <Alert color="failure" className="mt-2">{error}</Alert>
        )}
        {ok && (
          <Alert color="success" className="mt-2">{ok}</Alert>
        )}
        <form onSubmit={submit} className="flex flex-col gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <Label htmlFor="first_name" value="Имя" />
              <TextInput id="first_name" value={firstName} onChange={e => setFirstName(e.target.value)} color={errors.first_name ? 'failure' : undefined} required />
              {errors.first_name && <p className="mt-1 text-sm text-red-600">{errors.first_name}</p>}
            </div>
            <div>
              <Label htmlFor="last_name" value="Фамилия" />
              <TextInput id="last_name" value={lastName} onChange={e => setLastName(e.target.value)} color={errors.last_name ? 'failure' : undefined} required />
              {errors.last_name && <p className="mt-1 text-sm text-red-600">{errors.last_name}</p>}
            </div>
          </div>
          <div>
            <Label htmlFor="organization" value="Организация (опционально)" />
            <TextInput id="organization" value={organization} onChange={e => setOrganization(e.target.value)} placeholder="ООО РиэлтГрупп" />
          </div>
          <div>
            <Label htmlFor="phone" value="Телефон" />
            <TextInput id="phone" type="tel" value={phone} onChange={e => setPhone(formatPhone(e.target.value))} color={errors.phone ? 'failure' : undefined} required placeholder="+7 999 123-45-67" />
            {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone}</p>}
          </div>
          <div>
            <Label htmlFor="email" value="Email" />
            <TextInput id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} color={errors.email ? 'failure' : undefined} required />
            {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email}</p>}
          </div>
          <div>
            <Label htmlFor="password" value="Пароль" />
            <TextInput id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} color={errors.password ? 'failure' : undefined} required />
            {errors.password && <p className="mt-1 text-sm text-red-600">{errors.password}</p>}
          </div>

          <label className="flex items-start gap-2 text-sm">
            <input type="checkbox" className="mt-1" checked={agree} onChange={e => setAgree(e.target.checked)} />
            <span>
              Я соглашаюсь с <a className="underline" href="/docs/terms.html" target="_blank" rel="noreferrer">условиями использования</a> и <a className="underline" href="/docs/privacy.html" target="_blank" rel="noreferrer">политикой конфиденциальности</a>
            </span>
          </label>
          {errors.agree && <p className="-mt-2 text-sm text-red-600">{errors.agree}</p>}

          <Button type="submit" disabled={!canSubmit} color="blue">
            {loading ? (<div className="flex items-center gap-2"><Spinner size="sm" /> Регистрация...</div>) : 'Зарегистрироваться'}
          </Button>
          <div className="text-center text-sm text-gray-500">
            Уже есть аккаунт? <a href="/login" className="underline underline-offset-2 decoration-blue-500 hover:text-blue-700">Войти</a>
          </div>
        </form>
      </Card>
    </div>
  );
}
